export function getInternationalDateFormat(date) {
  const local = new Date(date);
  try {
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  } catch {
    return local.toJSON().slice(0, 10);
  }
  return local.toJSON().slice(0, 10);
}
